// Generated by genversion.
export const version = '1.25.0';
